import { useState, useEffect, useMemo } from 'react';
import { Form } from 'antd';
const { useWatch } = Form;

// AMR stores Source Delivered/Received as a channel number (from the dropdown: '1'/'2'/'3',
// or "Channel 1" etc. once loaded from the server — see formatSourceValue on the backend).
// AMI/MMR(Manual)/SCADA store a plain 'D'/'R' flag. Switching Meter File Source updates the
// dropdown's available options but does not clear whatever value was already in the form, so
// a stale value from before the switch (e.g. 'D' left over after changing to AMR) must be
// caught by validation rather than silently accepted.
const AMR_VALUE_PATTERN = /^(channel\s*)?\d+$/i;
const NON_AMR_VALUE_PATTERN = /^[dr]$/i;

export const isSourceValueValidForFileSource = (
  value: string | undefined | null,
  fileSource: string | undefined | null
): boolean => {
  if (!value) return true; // emptiness is handled by the `required` rule separately
  const trimmed = String(value).trim();
  return fileSource === 'AMR' ? AMR_VALUE_PATTERN.test(trimmed) : NON_AMR_VALUE_PATTERN.test(trimmed);
};

const useCoreInfoMeterSourceInfoSection = (form) => {
  const fileSource = useWatch('meterFileSource', form);
  const [kwhOptions, setKwhOptions] = useState<any[]>([]);

  const AmrOptions = useMemo(
    () => [
      { value: '1', label: 'Channel 1' },
      { value: '2', label: 'Channel 2' },
      { value: '3', label: 'Channel 3' },
    ],
    []
  );

  const OtherOptions = useMemo(
    () => [
      { value: 'D', label: 'D' },
      { value: 'R', label: 'R' },
    ],
    []
  );

  useEffect(() => {

    if (fileSource === 'AMR') {
      setKwhOptions(AmrOptions);
    } else {
      setKwhOptions(OtherOptions);
    }

  }, [fileSource, AmrOptions, OtherOptions]);

  return {
    fileSource,
    kwhOptions,
  };
};

export default useCoreInfoMeterSourceInfoSection;